import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    productId: string;
    checked: boolean;
};

type HandlerType = Handler<Parameter>;

const DispatchSetIncludeProducts: HandlerType = props => {
    props.dispatch({
        type: "Widgets/IncludeProducts/SetChecked",
        parameter: {
            productId: props.parameter.productId,
            checked: props.parameter.checked,
        },
    });
};

const chain = [DispatchSetIncludeProducts];

const setIncludeProducts = createHandlerChainRunner(chain, "SetIncludeProducts");
export default setIncludeProducts;
